import LayoutDefault from '@/layouts/LayoutDefault.vue';

import Admin from './admin.route';
import Gudang from './gudang.route';
import CashBill from './cash-bill.route';
import Kasir from './kasir.route';

let stockist = [
  {
    path: '/saldo',
    name: 'MyBalance',
    component: () => import('@/views/stockist/Balance.vue'),
    meta: {
      auth: true,
      title: 'Saldo Saya',
      layout: LayoutDefault,
      withoutParent: true,
    },
  },
];

stockist = stockist.concat(
    Admin.map(route => ({
        ...route,
        meta: {
            ...route.meta,
            parent: 'Admin'
        }
    })),
    Gudang.map(route => ({
        ...route,
        meta: {
            ...route.meta,
            parent: 'Gudang'
        }
    })),
    Kasir.map(route => ({
        ...route,
        meta: {
            ...route.meta,
            parent: 'Kasir'
        }
    })),
    CashBill.map(route => ({
        ...route,
        meta: {
            ...route.meta,
            parent: 'Cash Bill'
        }
    }))
);

export default stockist;
